<template>
    <div id="scribbles-wrap">



        <div id="controls">

            <div v-if="loading" id="loading">
                <loading-spinner></loading-spinner>
            </div>

            <div id="buttons">
                <a :href="'/item/' + itemId + '/production-overrides'" class="dims-btn">
                    <i class="fa fa-ruler-combined" aria-hidden="true"></i>
                    <b>Dims</b>
                </a>
                <button @click="scribbleCanvas.clear()" :disabled="loading || ! scribbleCanvas.hasChanges()">
                    <i class="fa fa-trash" aria-hidden="true"></i>
                    <b>Clear</b>
                </button>
                <button @click="stampMeasured()" :disabled="loading" title="Stamp the sheet: measured by you, dated now">
                    <i class="fa fa-check" aria-hidden="true"></i>
                    <b>Measured</b>
                </button>
                <button @click="loadScribbles('photo')" :disabled="loading" :class="{'has-photos': hasPhotos}">
                    <i class="fa fa-camera" aria-hidden="true"></i>
                    <b>Photos</b>
                </button>
                <button @click="loadScribbles('scribble')" :disabled="loading">
                    <i class="fa fa-book" aria-hidden="true"></i>
                    <b>Edits</b>
                </button>
                <button @click="saveScribble()" :disabled="loading || ! scribbleCanvas.hasChanges()">
                    <i class="fa fa-floppy-o" aria-hidden="true"></i>
                    <b>Save</b>
                </button>
                <button @click="scribbleCanvas.undo()" :disabled="loading || ! scribbleCanvas.hasChanges()">
                    <i class="fa fa-undo" aria-hidden="true"></i>
                    <b>Undo</b>
                </button>
                <button @click="scribbleMode='draw'" :disabled="loading" :class="['left-toggle', scribbleMode==='move' ? 'inactive' : '']">
                    <i class="fa fa-pencil" aria-hidden="true"></i>
                    <b>Draw</b>
                </button>
                <button @click="scribbleMode='move'" :disabled="loading" :class="['right-toggle', scribbleMode==='draw' ? 'inactive' : '']">
                    <i class="fa fa-arrows" aria-hidden="true"></i>
                    <b>Move</b>
                </button>
            </div>

            <div id="messages"></div>

<!--            <button @click="scribbleCanvas.clear()" :disabled="loading">-->
<!--                &nbsp; <i class="fa fa-trash" aria-hidden="true"></i> &nbsp;-->
<!--            </button>-->
<!--            <button @click="loadScribbles('photo')" :disabled="loading" :class="{'has-photos': hasPhotos}">-->
<!--                &nbsp; <i class="fa fa-camera" aria-hidden="true"></i> &nbsp;-->
<!--            </button>-->
<!--            <button @click="loadScribbles('scribble')" :disabled="loading">-->
<!--                &nbsp; <i class="fa fa-book" aria-hidden="true"></i> &nbsp;-->
<!--            </button>-->
<!--            <button @click="saveScribble()" :disabled="loading">-->
<!--                &nbsp; <i class="fa fa-floppy-o" aria-hidden="true"></i> &nbsp;-->
<!--            </button>-->
<!--            <button @click="scribbleCanvas.undo()" :disabled="loading">-->
<!--                &nbsp; <i class="fa fa-undo" aria-hidden="true"></i> &nbsp;-->
<!--            </button>-->
<!--            <button v-if="scribbleMode==='draw'" @click="toggleMode" :disabled="loading">-->
<!--                &nbsp; <i class="fa fa-pencil" aria-hidden="true"></i> &nbsp;-->
<!--            </button>-->
<!--            <button v-if="scribbleMode==='move'" @click="toggleMode" :disabled="loading">-->
<!--                &nbsp; <i class="fa fa-arrows" aria-hidden="true"></i> &nbsp;-->
<!--            </button>-->

<!--            <button @click="scribbleCanvas.clear()" :disabled="loading">-->
<!--                &nbsp; <i class="fa fa-trash" aria-hidden="true"></i> &nbsp; Clear &nbsp; &nbsp;-->
<!--            </button>-->
<!--            <button @click="loadScribbles('photo')" :disabled="loading" :class="{'has-photos': hasPhotos}">-->
<!--                &nbsp; <i class="fa fa-camera" aria-hidden="true"></i> &nbsp; Photos &nbsp; &nbsp;-->
<!--            </button>-->
<!--            <button @click="loadScribbles('scribble')" :disabled="loading">-->
<!--                &nbsp; <i class="fa fa-book" aria-hidden="true"></i> &nbsp; Edits &nbsp; &nbsp;-->
<!--            </button>-->
<!--            <button @click="saveScribble()" :disabled="loading">-->
<!--                &nbsp; <i class="fa fa-floppy-o" aria-hidden="true"></i> &nbsp; Save &nbsp; &nbsp;-->
<!--            </button>-->
<!--            <button @click="scribbleCanvas.undo()" :disabled="loading">-->
<!--                &nbsp; <i class="fa fa-undo" aria-hidden="true"></i> &nbsp; Undo &nbsp; &nbsp;-->
<!--            </button>-->
<!--            <button v-if="scribbleMode==='draw'" @click="toggleMode" :disabled="loading">-->
<!--                &nbsp; <i class="fa fa-pencil" aria-hidden="true"></i> &nbsp; Draw Mode &nbsp; &nbsp;-->
<!--            </button>-->
<!--            <button v-if="scribbleMode==='move'" @click="toggleMode" :disabled="loading">-->
<!--                &nbsp; <i class="fa fa-arrows" aria-hidden="true"></i> &nbsp; Move Mode &nbsp; &nbsp;-->
<!--            </button>-->


        </div>

        <v-easy-dialog v-model="scribblesDialog" :width="'80%'">
            <div class="v-easy-dialog-wrap scribbles-dialog">
                <div class="v-easy-dialog-title">
                    <span>{{ scribbles.length }} {{ scribblesDialogType==='photo' ? 'Photo' : 'Edit' }}{{ scribbles.length !== 1 ? 's' : '' }}</span>
                </div>

                <div class="v-easy-dialog-scrollable">
                    <div v-for="(scribble, num) in scribbles" class="edit">
                        <img class="scribble-thumb" :src="scribble.thumb_url" @click="showScribbleDialog(scribble)" />
                        <div class="scribble-meta">{{ num+1 }}) {{ scribble.stamp === 'measured' ? 'Measured — ' : '' }}{{ scribble.user.name }} @ {{ scribble.pretty_date }}</div>
                    </div>
                </div>

                <div class="v-easy-dialog-controls">
                    <template v-if="scribblesDialogType==='photo'">
                        <button class="btn btn-success" @click="uploadPhotoButtonClick">{{ isIpad ? 'Take Photo' : 'Upload Image' }}</button>
                        <input @change="uploadScribblesPhoto" id="photo" type="file" name="photo" accept="image/*" capture>
                    </template>
                    <button class="btn-qapp" @click="scribblesDialog=false">Close</button>

<!--                    v-model="selectedPhoto"  @change="handlePhotoSelection"-->
<!--                    <button v-if="scribblesDialogType==='photo'" class="btn-qapp" @click="uploadScribblesPhoto()">Upload Photo</button>-->
                </div>
            </div>
        </v-easy-dialog>

        <v-easy-dialog v-model="scribbleDialog" :width="'90%'">
            <div v-if="scribbleDialog" class="v-easy-dialog-wrap edit-crop-dialog">
                <div class="v-easy-dialog-title">
                    <span>{{ scribble.stamp === 'measured' ? 'Measured by' : 'by' }} {{ scribble.user.name }}</span>
                    <b>at {{ scribble.pretty_date }}</b>
                </div>

                <div class="v-easy-dialog-scrollable">
                    <img class="edit-crop" :src="scribble.url" />
                </div>

                <div class="v-easy-dialog-controls">
                    <button class="btn btn-danger" @click="deleteScribble()" :disabled="loading">Delete</button>
                    <button class="btn-qapp" @click="scribbleDialog=false">Close</button>
                </div>
            </div>
        </v-easy-dialog>

        <VPerfectSignature
            ref="signaturePad"
            :stroke-options="strokeOptions"
            :width="width"
            :height="height"
            :cacheSize="40"
            :backgroundColor="'rgba(0,0,0,0)'"
            :background-url="backgroundUrl"
            :mode="loading || scribblesDialog || scribbleDialog ? 'disable' : scribbleMode"
            :cssClass="'scribble-canvas'"
        />

    </div>
</template>

<!--<script lang="ts">-->
<script>
    import VPerfectSignature from './v-perfect-signature.esm.js'
    import miniToastr from "mini-toastr";
    import {default as api} from "../../api";
    import LoadingSpinner from '../LoadingSpinner';
    import VEasyDialog from 'v-easy-dialog'


    export default {

        components: {
            VPerfectSignature,
            miniToastr,
            api,
            LoadingSpinner,
            VEasyDialog,
        },

        data: () => ({
            loading: true,
            strokeOptions: {
                size: 5,
                thinning: 0.5,
                smoothing: 0.5,
                streamline: 0.5,
            },
            defaultStrokeSize: 5,
            scribbleCanvas: null,
            pixelRatio: null,
            canvasWidth: 0,
            canvasHeight: 0,
            visualViewport: {},
            controlsDiv: null,
            scribbleMode: 'move',
            scribblesDialog: false,
            scribblesDialogType: '',
            scribbles: [],
            scribbleDialog: false,
            scribble: {},
            canvasElement: null,
            isIpad: null,
            hasPhotos: null,
        }),

        props: {
            itemId: {
                type: Number,
                required: true,
            },
            backgroundUrl: {
                type: String,
                required: true,
            },
            width: {
                type: String,
                required: true,
            },
            height: {
                type: String,
                required: true,
            },
            hasPhotosProp: {
                type: Boolean,
                required: true,
            },
        },

        async created() {
            window.Echo.channel('scribbles.'+this.itemId)
                .listen('ScribbleCreated', e => {
                    this.handleBroadcast(e, 'ScribbleCreated');
                })
                .listen('ScribbleDeleted', e => {
                    this.handleBroadcast(e, 'ScribbleDeleted');
                });
        },

        destroyed() {
            window.Echo.leaveChannel('scribbles.'+this.itemId);
        },

        mounted() {
            this.scribbleCanvas = this.$refs.signaturePad;
            this.controlsDiv = document.getElementById('controls');
            this.canvasElement = document.getElementsByClassName('scribble-canvas')[0];
            this.isIpad = /Macintosh/i.test(navigator.userAgent) && navigator.maxTouchPoints && navigator.maxTouchPoints > 1;
            this.hasPhotos = this.hasPhotosProp;

            this.setupStyles();

            window.addEventListener('scroll', () => this.resizeControls(this.controlsDiv));
            window.addEventListener('resize', () => this.resizeControls(this.controlsDiv));

            this.loading = false;

            miniToastr.init({
                timeout: 3000,
                appendTarget: document.getElementById('messages'),
            });
        },

        methods: {
            handleBroadcast(event, name='') {
                console.log(`Broadcast: ${name}`, event);

                if (event.type === 'scribble')
                    this.reloadBackground();

                if (event.type === 'photo')
                    this.hasPhotos = true;
            },
            setupStyles() {
                document.getElementsByClassName('container-fluid ui-content')[0].style.padding = '0';
                document.getElementsByClassName('ui-page')[0].style.backgroundColor = 'transparent';
                document.body.style.backgroundColor = '#e3e9f2';
                this.applyMode();
            },
            toggleMode() {
                this.scribbleMode = this.scribbleMode === 'draw' ? 'move' : 'draw';
            },
            updateStrokeSize() {
                let scale = visualViewport.scale === 1 ? 1 : window.innerWidth / document.documentElement.clientWidth;
                this.strokeOptions.size = Math.round(this.defaultStrokeSize * scale);
            },
            applyMode() {
                if (this.scribbleMode === 'draw' || this.scribblesDialog || this.scribbleDialog) {
                    document.body.style.touchAction = "none";
                    document.documentElement.style.touchAction = "none";
                    document.body.style.overflow = "hidden";
                    document.documentElement.style.overflow = "hidden";
                    document.body.style.userSelect = "none";
                    document.documentElement.style.userSelect = "none";
                }
                else if (this.scribbleMode === 'move') {
                    document.body.style.touchAction = "auto";
                    document.documentElement.style.touchAction = "auto";
                    document.body.style.overflow = "auto";
                    document.documentElement.style.overflow = "auto";
                    document.body.style.userSelect = "auto";
                    document.documentElement.style.userSelect = "auto";
                }
            },
            resizeControls(controls) {
                let scale = visualViewport.scale === 1 ? 1 : window.innerWidth / document.documentElement.clientWidth;
                let navHeight = 40;
                let controlTop = window.pageYOffset + (navHeight * scale) - (controls.clientHeight * (1-scale)) + 'px';
                let scrollBarWidth = window.innerWidth - document.documentElement.clientWidth;

                controls.style.position = 'absolute';
                controls.style.left = window.pageXOffset + 'px';
                controls.style.top = controlTop;
                controls.style.transform = "scale(" + scale + ")";

                this.canvasElement.style.marginTop = ((90 + navHeight) * scale) + 'px'
            },
            showScribbleDialog(scribble) {
                this.scribble = scribble;
                this.scribbleDialog = true;
            },
            loadScribbles(type) {
                this.loading = true;
                this.scribblesDialogType = type;
                api.getScribbles(this.itemId, type).then(data => {
                    this.loading = false;
                    if (api.responseHasErrors(data)) return;
                    this.scribbles = data.scribbles;
                    this.scribblesDialog = true;

                    if (this.scribbles.length === 0 && this.scribblesDialogType === 'photo')
                        this.hasPhotos = false;
                });
            },
            // Deletes scribble currently shown in scribble dialog
            deleteScribble() {
                this.loading = true;
                api.deleteScribble(this.itemId, this.scribble.id, this.scribblesDialogType).then(data => {
                    this.loading = false;
                    if (api.responseHasErrors(data)) return;
                    this.scribbles = data.scribbles;
                    this.scribbleDialog = false;

                    if (this.scribbles.length === 0 && this.scribblesDialogType === 'photo')
                        this.hasPhotos = false;

                    if (this.scribblesDialogType === 'scribble')
                        this.reloadBackground();
                });
            },
            saveScribble() {
                if (! this.scribbleCanvas.hasChanges()) {
                    miniToastr.error('No changes have been made yet...', '', 5000);
                    return;
                }

                this.loading = true;

                // Delegate this to macro queue so that loading state updates in UI first
                // This is because saving all the canvas data causes browser to hang for 2 seconds
                setTimeout(() => {
                    this.scribbleCanvas.save().then(dataUrl => {
                        api.saveScribble(this.itemId, dataUrl).then(data => {
                            this.loading = false;
                            if (api.responseHasErrors(data)) return;
                            this.reloadBackground();
                        });
                    });
                }, 0);
            },
            reloadBackground() {
                this.scribbleCanvas.setBackgroundUrl(this.backgroundUrl, true);
            },
            stampMeasured() {
                this.loading = true;
                api.stampMeasured(this.itemId).then(data => {
                    this.loading = false;
                    if (api.responseHasErrors(data)) return;
                    miniToastr.success('Stamped: measured by you, dated now', '', 3000);
                    this.reloadBackground();
                });
            },
            updateDims() {
                this.pixelRatio = window.devicePixelRatio;

                let canvas = this.scribbleCanvas.getCanvasElement();
                this.canvasWidth = canvas.width;
                this.canvasHeight = canvas.height;

                this.visualViewport = window.visualViewport;
            },
            uploadPhotoButtonClick() {
                document.getElementById('photo').click();
            },
            uploadScribblesPhoto(event) {
                this.loading = true;
                api.uploadScribblePhoto(this.itemId, event.target.files[0]).then(data => {
                    this.loading = false;
                    event.target.value = '';
                    if (api.responseHasErrors(data)) return;
                    if (data.error) return;
                    this.scribbles = data.scribbles;
                    this.hasPhotos = true;
                });
            },
        },
        watch: {
            scribblesDialog: function() {
                this.updateStrokeSize();
                this.applyMode();
            },
            scribbleDialog: function() {
                this.updateStrokeSize();
                this.applyMode();
            },
            scribbleMode: function() {
                this.updateStrokeSize();
                this.applyMode();
            },
        },
    }
</script>

<style>
    #scribbles-wrap {
    }
    #scribbles-wrap .scribble-canvas {
        margin-top: 130px;
        z-index: 2;
        position: relative;
    }
    #controls {
        position: absolute;
        z-index: 3;
        justify-content: center;
        display: flex;
        flex-direction: row;
        top: 40px;
        left: 0;
        width: 100%;
        height: 90px;
        padding: 15px;
        background-color: #283142;
        box-sizing: border-box;
        transition: all 0s;
        transform-origin: 0 100%;
        user-select: none;
        touch-action: none;
    }
    #buttons {
        display: flex;
        margin-left: calc((100vw - 100%) - 30px);
    }
    #controls button {
        margin: 0 16px;
        font-weight: bold;
        display: flex;
        flex-direction: column;
        padding: 10px 25px;
        line-height: 0;
        justify-content: space-evenly;
        border-radius: 5px;
        align-items: center;
        background-color: #e3e5ea;
        border-right: 2px solid #9ea5b5;
        border-bottom: 2px solid #9ea5b5;
        border-top: 2px solid #fff;
        border-left: 2px solid #fff;
    }
    #controls button .fa {
        font-size: 26px;
        padding: 0;
        margin: 0;
    }
    #controls button b {
        font-size: 12px;
        padding: 10px 0 0 0;
        margin: 0;
    }

    #controls button.inactive,
    #controls button:disabled {
        opacity: 0.5;
    }
    #controls button.inactive {
        background-color: #dbe2f5;
        color: #0e0e0f;
    }
    #controls button:disabled {
        background-color: #bfc2cc;
        color: #2d323a;
    }

    /* Active (tap) feedback — works on touch and mouse */
    #controls button:active:not(:disabled) {
        transform: scale(0.95);
        border-top: 2px solid #9ea5b5;
        border-left: 2px solid #9ea5b5;
        border-bottom: 2px solid #fff;
        border-right: 2px solid #fff;
        background-color: #d0d3da;
    }

    /* Hover only on devices that support it (not touch) */
    @media (hover: hover) {
        #controls button:hover:not(:disabled):not(.inactive) {
            background-color: #cdd0d8;
        }
        #controls button.inactive:hover {
            opacity: 0.65;
        }
    }
    #controls button.left-toggle {
        margin-right: 0;
        border-top-right-radius: 0;
        border-bottom-right-radius: 0;
        border-right: 1px solid #868a93;
    }
    #controls button.right-toggle {
        margin-left: 0;
        border-top-left-radius: 0;
        border-bottom-left-radius: 0;
        border-left: 1px solid #868a93;
    }

    .mini-toastr {
        position: absolute !important;
        right: 30px !important;
        top: 23px !important;
    }
    .mini-toastr-notification__message {
        padding: 0 !important;
    }
    #messages {
        position: absolute;
        right: 0;
        top: 0;
    }
    .mini-toastr__notification.-success {
        background-color: #15831a !important;
    }

    #loading {
        position: absolute;
        top: 27px;
        left: 30px;
        z-index: 2000;
    }
    #loading .hollow-dots-spinner .dot {
        border-color: #f4700f;
    }

    .v-easy-dialog--backdrop {
        background-color: #00000080;
    }
    .v-easy-dialog--backdrop-btn {
        opacity: 0;
    }
    .v-easy-dialog--content-container {
        display: flex;
        overflow-y: auto;
        position: absolute;
    }
    .v-easy-dialog-wrap {
        display: flex;
        flex-direction: column;
        border-radius: 10px;
        background-color: white;
        box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000);
    }
    .v-easy-dialog-wrap div {
        padding: 1rem;
        width: 100%;
        border-bottom: 1px solid #cbcbcb;
        display: flex;
    }
    .v-easy-dialog-wrap div:last-child {
        border: none;
    }
    .v-easy-dialog-title {
        display: flex;
        flex-direction: column;
    }
    .v-easy-dialog-controls {
        display: flex;
        justify-content: flex-end;
        border-top-width: calc(1px * calc(1 - 0));
        border-bottom-width: calc(1px * 0);
    }
    .v-easy-dialog-scrollable {
        flex-grow: 1;
        overflow-y: auto;
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        justify-content: space-around;
    }

    .v-easy-dialog-controls button {
        margin: 0 10px 0 40px;
        font-weight: bold;
    }

    .scribbles-dialog, .edit-crop-dialog {
        touch-action: auto;
        user-select: auto;
    }
    .scribble-thumb {
        cursor: pointer;
        width: 100%;
        height: auto;
    }
    .edit {
        width: 200px !important;
        flex-direction: column;
        justify-content: space-between;
        margin: 20px;
        border: 1px solid #ccc !important;
        border-radius: 4px;
    }
    .scribble-meta {
        font-size: 14px;
        padding: 0 !important;
        margin-top: 10px;
        color: #595959;
    }
    .edit-crop {
        width: 100%;
        height: auto;
    }

    #photo {
        display: none;
    }
    .has-photos {
        background-color: #f59112;
        color: black;
        border-radius: 4px;
    }
    .dims-btn {
        margin: 0 16px;
        font-weight: bold;
        display: flex;
        flex-direction: column;
        padding: 10px 25px;
        line-height: 0;
        justify-content: space-evenly;
        border-radius: 5px;
        align-items: center;
        background-color: #f0ad4e;
        border-right: 2px solid #c77c00;
        border-bottom: 2px solid #c77c00;
        border-top: 2px solid #ffe0a0;
        border-left: 2px solid #ffe0a0;
        text-decoration: none;
        color: #333;
        margin-right: 30px;
    }
    .dims-btn .fa {
        font-size: 26px;
        padding: 0;
        margin: 0;
    }
    .dims-btn b {
        font-size: 12px;
        padding: 10px 0 0 0;
        margin: 0;
    }
    .dims-btn:active {
        transform: scale(0.95);
        background-color: #d58512;
        border-top: 2px solid #c77c00;
        border-left: 2px solid #c77c00;
        border-bottom: 2px solid #ffe0a0;
        border-right: 2px solid #ffe0a0;
    }
    @media (hover: hover) {
        .dims-btn:hover {
            background-color: #ec971f;
            text-decoration: none;
            color: #333;
        }
    }

</style>
